import { withVenmoPaymentMethodProps } from 'viewModel/venmo/venmoPaymentMethod/withVenmoPaymentMethodProps';
import VenmoPaymentMethod from 'components/Venmo/VenmoPaymentMethod/VenmoPaymentMethod';

export default withVenmoPaymentMethodProps(VenmoPaymentMethod);
